import { SVGProps } from 'react';

interface RectangleHistoryCirclePlusProps extends SVGProps<SVGSVGElement> {
  size?: number;
}

/**
 * Rectangle/history with circle-plus (e.g. for "add to playlist" or schedule).
 * TODO: Move to @raydiant/raydial when ready.
 */
const RectangleHistoryCirclePlus = ({
  size = 22,
  ...props
}: RectangleHistoryCirclePlusProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 22 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2.125 15.4062H11.5547C11.9531 16.0371 12.4844 16.6016 13.082 17H2.125C0.929688 17 0 16.0703 0 14.875V7.4375C0 6.27539 0.929688 5.3125 2.125 5.3125H14.875C15.6387 5.3125 16.3359 5.74414 16.7012 6.4082C16.6348 6.4082 16.5352 6.375 16.4688 6.375C15.5723 6.375 14.7422 6.57422 14.0117 6.90625H2.125C1.82617 6.90625 1.59375 7.17188 1.59375 7.4375V14.875C1.59375 15.1738 1.82617 15.4062 2.125 15.4062ZM14.6094 2.65625C15.041 2.65625 15.4062 3.02148 15.4062 3.45312C15.4062 3.91797 15.041 4.25 14.6094 4.25H2.39062C1.92578 4.25 1.59375 3.91797 1.59375 3.45312C1.59375 3.02148 1.92578 2.65625 2.39062 2.65625H14.6094ZM13.0156 0C13.4473 0 13.8125 0.365234 13.8125 0.796875C13.8125 1.26172 13.4473 1.59375 13.0156 1.59375H3.98438C3.51953 1.59375 3.1875 1.26172 3.1875 0.796875C3.1875 0.365234 3.51953 0 3.98438 0H13.0156ZM16.4688 7.4375C18.1621 7.4375 19.7227 8.36719 20.5859 9.82812C21.4492 11.3223 21.4492 13.1484 20.5859 14.6094C19.7227 16.1035 18.1621 17 16.4688 17C14.7422 17 13.1816 16.1035 12.3184 14.6094C11.4551 13.1484 11.4551 11.3223 12.3184 9.82812C13.1816 8.36719 14.7422 7.4375 16.4688 7.4375ZM17 10.0938C17 9.82812 16.7344 9.5625 16.4688 9.5625C16.1699 9.5625 15.9375 9.82812 15.9375 10.0938V11.6875H14.3438C14.0449 11.6875 13.8125 11.9531 13.8125 12.2188C13.8125 12.5176 14.0449 12.75 14.3438 12.75H15.9375V14.3438C15.9375 14.6426 16.1699 14.875 16.4688 14.875C16.7344 14.875 17 14.6426 17 14.3438V12.75H18.5938C18.8594 12.75 19.125 12.5176 19.125 12.2188C19.125 11.9531 18.8594 11.6875 18.5938 11.6875H17V10.0938Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default RectangleHistoryCirclePlus;
